import { render, staticRenderFns } from "./IcoChevronUp.vue?vue&type=template&id=0ac333fc"
import script from "./IcoChevronUp.vue?vue&type=script&lang=js"
export * from "./IcoChevronUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports